<ngb-toast [header]="toast.Title" [class]="toast.Config.BoxClass">
  {{toast.Message}}
</ngb-toast>
